import { Check, Info, Loader2, RotateCcw, X } from 'lucide-react';
import { admin, palette, typography } from '../../../../styles/tokens';
import { IconButton } from './parts';

export type ConversationalRowState = 'saving' | 'saved' | 'failed';

export interface ConversationalRow {
  rowKey: string;
  clientId: string | null;
  name: string;
  phone: string;
  email: string;
  state: ConversationalRowState;
  errorMessage?: string;
}

interface RowItemProps {
  row: ConversationalRow;
  onRetry: () => void;
  onRemove: () => void;
}

export default function RowItem({ row, onRetry, onRemove }: RowItemProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        padding: '12px 16px',
        borderBottom: `1px solid ${palette.g100}`,
        gap: 12,
      }}
    >
      <div style={{ width: 18, marginTop: 2 }}>
        {row.state === 'saving' && <Loader2 size={16} color={palette.g500} />}
        {row.state === 'saved' && <Check size={16} color={palette.green} />}
        {row.state === 'failed' && <Info size={16} color={palette.red} />}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: typography.size.body,
            fontWeight: typography.weight.medium,
            color: admin.header,
          }}
        >
          {row.name}
        </div>
        <div style={{ fontSize: typography.size.caption, color: admin.caption }}>
          {row.phone || 'no phone'} · {row.email || 'no email'}
        </div>
        {row.state === 'failed' && row.errorMessage && (
          <div
            style={{
              marginTop: 4,
              fontSize: typography.size.caption,
              color: palette.red,
            }}
          >
            {row.errorMessage}
          </div>
        )}
      </div>
      <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
        {row.state === 'failed' && (
          <IconButton onClick={onRetry} label="Retry">
            <RotateCcw size={14} />
          </IconButton>
        )}
        <IconButton onClick={onRemove} label="Remove">
          <X size={14} />
        </IconButton>
      </div>
    </div>
  );
}
